/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Region = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
        name: {
            type: 'Translation',
            isRequired: true,
        },
        areaOfInterestIds: {
            type: 'array',
            contains: {
                type: 'number',
            },
            isRequired: true,
        },
        display: {
            type: 'boolean',
            isRequired: true,
        },
        image: {
            type: 'any-of',
            contains: [{
                type: 'Image',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        countryCode: {
            type: 'CountryCode',
            isRequired: true,
        },
    },
} as const;
